import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getPublicImageUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${API}/files/${path}`;
};

export const api = {
  // Auth
  signup: (data) => axios.post(`${API}/auth/signup`, data),
  login: (data) => axios.post(`${API}/auth/login`, data),
  verifyEmail: (token) => axios.post(`${API}/auth/verify-email?token=${token}`),
  getMe: () => axios.get(`${API}/auth/me`, { headers: getAuthHeader() }),
  forgotPassword: (email) => axios.post(`${API}/auth/forgot-password?email=${email}`),
  resetPassword: (token, new_password) => axios.post(`${API}/auth/reset-password?token=${token}&new_password=${new_password}`),
  changePassword: (current_password, new_password) => axios.put(`${API}/auth/change-password?current_password=${current_password}&new_password=${new_password}`, {}, { headers: getAuthHeader() }),
  
  // Public
  getPublicHairstyles: (params) => axios.get(`${API}/public/hairstyles`, { params }),
  getHairstyle: (id) => axios.get(`${API}/public/hairstyles/${id}`),
  getCategories: () => axios.get(`${API}/public/categories`),
  getTestimonials: (params) => axios.get(`${API}/public/testimonials`, { params }),
  getFAQ: () => axios.get(`${API}/public/faq`),
  getPolicies: () => axios.get(`${API}/public/policies`),
  getBrandSettings: () => axios.get(`${API}/public/brand-settings`),
  submitContact: (data) => axios.post(`${API}/public/contact`, data),
  
  // Customer
  getMyBookings: () => axios.get(`${API}/customer/bookings`, { headers: getAuthHeader() }),
  getMyPayments: () => axios.get(`${API}/customer/payments`, { headers: getAuthHeader() }),
  updateProfile: (data) => axios.put(`${API}/customer/profile`, data, { headers: getAuthHeader() }),
  
  // Booking
  createBooking: (data) => axios.post(`${API}/bookings`, data, { headers: getAuthHeader() }),
  getBooking: (id) => axios.get(`${API}/bookings/${id}`, { headers: getAuthHeader() }),
  createPayment: (data) => axios.post(`${API}/payments`, null, { params: data, headers: getAuthHeader() }),
  
  // Admin
  getCustomers: () => axios.get(`${API}/admin/customers`, { headers: getAuthHeader() }),
  approveCustomer: (id) => axios.put(`${API}/admin/customers/${id}/approve`, {}, { headers: getAuthHeader() }),
  declineCustomer: (id) => axios.put(`${API}/admin/customers/${id}/decline`, {}, { headers: getAuthHeader() }),
  
  getAllHairstyles: () => axios.get(`${API}/admin/hairstyles`, { headers: getAuthHeader() }),
  createHairstyle: (data) => axios.post(`${API}/admin/hairstyles`, data, { headers: getAuthHeader() }),
  updateHairstyle: (id, data) => axios.put(`${API}/admin/hairstyles/${id}`, data, { headers: getAuthHeader() }),
  deleteHairstyle: (id) => axios.delete(`${API}/admin/hairstyles/${id}`, { headers: getAuthHeader() }),
  
  getAllBookings: () => axios.get(`${API}/admin/bookings`, { headers: getAuthHeader() }),
  updateBookingStatus: (id, status) => axios.put(`${API}/admin/bookings/${id}/status?status=${status}`, {}, { headers: getAuthHeader() }),
  
  getAllPayments: () => axios.get(`${API}/admin/payments`, { headers: getAuthHeader() }),
  verifyPayment: (id, verified) => axios.put(`${API}/admin/payments/${id}/verify?verified=${verified}`, {}, { headers: getAuthHeader() }),
  
  getAdminBrandSettings: () => axios.get(`${API}/admin/brand-settings`, { headers: getAuthHeader() }),
  updateBrandSettings: (data) => axios.put(`${API}/admin/brand-settings`, data, { headers: getAuthHeader() }),
  
  getAllTestimonials: () => axios.get(`${API}/admin/testimonials`, { headers: getAuthHeader() }),
  createTestimonial: (data) => axios.post(`${API}/admin/testimonials`, data, { headers: getAuthHeader() }),
  updateTestimonial: (id, data) => axios.put(`${API}/admin/testimonials/${id}`, data, { headers: getAuthHeader() }),
  deleteTestimonial: (id) => axios.delete(`${API}/admin/testimonials/${id}`, { headers: getAuthHeader() }),
  
  getAllFAQ: () => axios.get(`${API}/admin/faq`, { headers: getAuthHeader() }),
  createFAQ: (data) => axios.post(`${API}/admin/faq`, data, { headers: getAuthHeader() }),
  updateFAQ: (id, data) => axios.put(`${API}/admin/faq/${id}`, data, { headers: getAuthHeader() }),
  deleteFAQ: (id) => axios.delete(`${API}/admin/faq/${id}`, { headers: getAuthHeader() }),
  
  getAllPolicies: () => axios.get(`${API}/admin/policies`, { headers: getAuthHeader() }),
  createPolicy: (data) => axios.post(`${API}/admin/policies`, data, { headers: getAuthHeader() }),
  updatePolicy: (id, data) => axios.put(`${API}/admin/policies/${id}`, data, { headers: getAuthHeader() }),
  deletePolicy: (id) => axios.delete(`${API}/admin/policies/${id}`, { headers: getAuthHeader() }),
  
  getReports: () => axios.get(`${API}/admin/reports`, { headers: getAuthHeader() }),
  
  // WhatsApp settings (uses brand settings)
  getWhatsAppSettings: () => axios.get(`${API}/public/brand-settings`),
  
  // Chat
  sendChatMessage: (data) => axios.post(`${API}/chat`, data),
  getChatHistory: (sessionId) => axios.get(`${API}/chat/history/${sessionId}`),
  
  // Leads
  captureLead: (data) => axios.post(`${API}/leads`, data),
  getLeads: () => axios.get(`${API}/admin/leads`, { headers: getAuthHeader() }),
  updateLeadStatus: (id, status) => axios.put(`${API}/admin/leads/${id}/status?status=${status}`, {}, { headers: getAuthHeader() }),
  deleteLead: (id) => axios.delete(`${API}/admin/leads/${id}`, { headers: getAuthHeader() }),
  
  // Storage
  uploadFile: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/upload`, formData, { headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' } });
  },
  getFileUrl: (path, token) => `${API}/files/${path}?auth=${token}`
};
